/* FAQ-pagina: categorie-filter + zoeken. Accordions zijn native <details>. */
class SkFaqPage extends HTMLElement {
  connectedCallback() {
    this.navBtns = [...this.querySelectorAll('.sk-faqp__nav-btn')];
    this.groups = [...this.querySelectorAll('.sk-faqp__group')];
    this.searchInput = this.querySelector('.sk-faqp__search-input');
    this.noResults = this.querySelector('.sk-faqp__noresults');
    this.activeCat = 'all';

    this.navBtns.forEach((btn) => {
      btn.addEventListener('click', () => this.setCategory(btn.dataset.cat));
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => this.onSearch());
    }

    // standaard: eerste categorie tonen (zoals de referentie)
    if (this.groups.length) {
      this.setCategory(this.groups[0].dataset.cat);
    }
  }

  setCategory(cat) {
    this.activeCat = cat;
    if (this.searchInput) this.searchInput.value = '';
    this.navBtns.forEach((b) => b.classList.toggle('is-active', b.dataset.cat === cat));
    this.groups.forEach((g) => {
      g.hidden = !(cat === 'all' || g.dataset.cat === cat);
    });
    this.querySelectorAll('[data-q]').forEach((it) => {
      it.hidden = false;
    });
    if (this.noResults) this.noResults.hidden = true;
  }

  onSearch() {
    const q = (this.searchInput.value || '').trim().toLowerCase();
    if (!q) {
      this.setCategory(this.activeCat);
      return;
    }
    // tijdens zoeken: alle categorieën doorzoeken, niet-matchende items/groepen verbergen
    let anyMatch = false;
    this.groups.forEach((g) => {
      let groupMatch = false;
      g.querySelectorAll('[data-q]').forEach((it) => {
        const haystack = ((it.dataset.q || '') + ' ' + it.textContent).toLowerCase();
        const match = haystack.indexOf(q) !== -1;
        it.hidden = !match;
        if (match) {
          groupMatch = true;
          anyMatch = true;
        }
      });
      g.hidden = !groupMatch;
    });
    if (this.noResults) this.noResults.hidden = anyMatch;
  }
}

if (!customElements.get('sk-faq-page')) {
  customElements.define('sk-faq-page', SkFaqPage);
}
